import { ReserveCoinInformations, ValidateCoinName } from '@/models/coin-setup';

import APIService from '.';

export default class CoinSetupService extends APIService {
  getCoin() {
    return this.get('/admin/business-coin-setup');
  }

  reserveCoinInformations(
    reserveInformations: ReserveCoinInformations,
    recaptcha?: string
  ) {
    return this.post(
      '/admin/business-coin-setup/reserve',
      reserveInformations,
      { ...(recaptcha && { headers: { recaptcha } }) }
    );
  }

  validateCoinName(validateInformations: ValidateCoinName, recaptcha?: string) {
    return this.get<{ valid: boolean }>(
      '/admin/business-coin-setup/validate-coin-name',
      {
        ...(recaptcha && { headers: { recaptcha } }),
        params: validateInformations
      }
    );
  }

  identifyUser(uid: string) {
    return this.post('/admin/business-coin-setup/user', { uid });
  }

  identifyBusiness(data: { uid: string; businessId: string }) {
    return this.post('/admin/business-coin-setup/business', data);
  }
}
